<template>
    <v-container class="fill-height">
      <v-responsive>
        <v-card>
          <v-card-title class="text-center">
            403 Forbidden
          </v-card-title>
          <v-card-subtitle class="text-center">
            You do not have access to this chatbot
          </v-card-subtitle>
          <v-card-text>
            <v-img class="mx-auto" src="../assets/images/SAD_BOB.png" max-width="400"/>
          </v-card-text>
        </v-card>
      </v-responsive>
    </v-container>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  const q = new URLSearchParams(location.search).get('botName')
  const botName = Array.isArray(q) ? q[0] : q
  if (typeof botName === 'string' && botName) {
    localStorage.removeItem(`jwt-${botName}`)
  }
})
</script>

<style>
/* Optional: Add any additional styling here */
</style>
